<template>
  <div class="credit-card-payment-clients-form">
    <a-spin :spinning="loading" :tip="labels.form.loading">
      <ValidationObserver ref="observer">
        <a-form
          :model="variable"
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(handleSubmit)"
        >
          <a-row type="flex" justify="start" :gutter="30">
            <a-col :span="24">
              <a-card>
                <a-row type="flex" justify="end" :gutter="24">
                  <a-col>
                    <a-button
                      type="primary"
                      icon="plus"
                      :loading="loading"
                      @click="addQuestion()"
                      class="btn-add"
                      ghost
                    >
                      <span>{{ labels.form.add }}</span>
                    </a-button>
                  </a-col>
                  <a-col :span="24">
                    <a-divider />
                  </a-col>
                </a-row>

                <a-row
                  type="flex"
                  justify="space-between"
                  :gutter="24"
                  class="border-bottom"
                >
                  <a-col :span="24">
                    <a-collapse
                      v-model="activeKey"
                      @change="changeCollapse"
                      accordion
                    >
                      <a-collapse-panel
                        v-for="(item, index) in variable.value"
                        :key="index"
                        :header="item.question"
                      >
                        <ValidationObserver ref="formObserver">
                          <a-form
                            :model="form"
                            slot-scope="{ validate }"
                            @submit.prevent="validate().then(handleAdd)"
                          >
                            <a-row type="flex" justify="start" :gutter="30">
                              <a-col :span="24">
                                <Input
                                  type="text"
                                  :label="labels.form.question"
                                  :placeholder="labels.form.question"
                                  v-model="form.question"
                                  rules="required"
                                />
                              </a-col>
                            </a-row>
                            <a-row type="flex" justify="start" :gutter="30">
                              <a-col :span="24">
                                <a-form-item :label="labels.form.answer">
                                  <wysiwyg
                                    v-model="form.answer"
                                    :minHeight="600"
                                  />
                                </a-form-item>
                              </a-col>
                            </a-row>
                            <a-row type="flex" justify="start" :gutter="30">
                              <a-col :span="24">
                                <Input
                                  type="text"
                                  :label="labels.form.link"
                                  :placeholder="labels.form.link"
                                  v-model="form.link"
                                  rules="required"
                                />
                              </a-col>
                            </a-row>
                            <a-row type="flex" justify="start" :gutter="30">
                              <a-col :span="24">
                                <a-button
                                  type="primary"
                                  :loading="submitting"
                                  @click="validate().then(handleEdit(index))"
                                  class="btn-submit"
                                  style="margin-right: 16px"
                                >
                                  <span>{{ labels.form.save }}</span>
                                </a-button>
                                <a-button
                                  type="danger"
                                  :loading="submitting"
                                  @click="validate().then(handleDelete(index))"
                                  class="btn-submit"
                                >
                                  <span>{{ labels.form.delete }}</span>
                                </a-button>
                              </a-col>
                            </a-row>
                          </a-form>
                        </ValidationObserver>
                      </a-collapse-panel>
                    </a-collapse>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>
        </a-form>
      </ValidationObserver>
    </a-spin>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import labels from "@/utils/labels";
import { mapActions } from "vuex";
import Input from "../../../components/core/VeeValidateForm/Input.vue";
import * as _ from "lodash";
import { CRAUE_CONFIG } from "../../../utils/utils";

const defaultVariable = {
  name: "frequently_asked_questions",
  value: [],
};

const defaultForm = {
  index: undefined,
  slug: "",
  question: "",
  answer: "",
  link: "",
  status: "1",
};

export default {
  name: "FrequentQuestionsClientForm",
  components: {
    ValidationObserver,
    Input,
  },
  data() {
    return {
      labels: labels.systemConfig.tabs.frequentQuestionsPageClient,
      exception: labels.exception,
      loading: false,
      submitting: false,
      variable: _.cloneDeep(defaultVariable),
      form: _.cloneDeep(defaultForm),

      activeKey: [],
      text: "abc",
    };
  },
  async created() {
    this.resetForm();
    this.handleFetchCarouselHomePageClient();
  },
  methods: {
    ...mapActions("systemConfig", ["getCraueConfigByName", "saveCraueConfig"]),
    async handleFetchCarouselHomePageClient() {
      this.variable = _.cloneDeep(defaultVariable);
      try {
        this.loading = true;
        const { data } = await this.getCraueConfigByName(
          CRAUE_CONFIG.VAR_FREQUENTLY_ASKED_QUESTIONS
        );
        Object.assign(this.variable, {
          ...data,
          value: JSON.parse(data.value),
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    addQuestion() {
      const name = "Pregunta #" + (this.variable.value.length + 1);
      this.variable.value.push({
        slug: _.kebabCase(name),
        question: name,
        answer: "",
        link: "",
      });
    },
    changeCollapse(key) {
      if (key != undefined) {
        this.form.slug = _.kebabCase(this.variable.value[key].question);
        this.form.question = this.variable.value[key].question;
        this.form.answer = this.variable.value[key].answer;
        this.form.link = this.variable.value[key].link;
      }
    },
    async handleSubmit() {
      const { variable, saveCraueConfig } = this;
      if (this.submitting) return;
      try {
        this.submitting = true;
        const { message } = await saveCraueConfig({
          variables: [
            {
              ...variable,
              value: JSON.stringify(variable.value),
            },
          ],
        });
        await this.handleFetchCarouselHomePageClient();
        this.$message.success(message);
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
        this.$log.error(error);
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.form = _.cloneDeep(defaultForm);
      if (this.$refs.formObserver) this.$refs.formObserver.reset();
    },
    async handleAdd() {
      try {
        const { form, variable } = this;
        const { question, answer, link, status, index = null } = form;
        const { value } = variable;
        if (index !== null) {
          value.splice(index, 1, {
            slug: _.kebabCase(question),
            question,
            answer,
            link,
            status,
          });
        } else {
          value.push({
            slug: _.kebabCase(question),
            question,
            answer,
            link,
            status,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleDelete(index) {
      const { value } = this.variable;
      value.splice(index, 1);
      this.handleSubmit();
      this.activeKey = _.cloneDeep([]);
    },
    handleCancel() {
      this.resetForm();
    },
    handleEdit(index) {
      this.form = _.cloneDeep({ ...this.form, index });
      this.handleAdd();
      this.handleSubmit();
    },
  },
  beforeDestroy() {
    this.form = _.cloneDeep(defaultForm);
    this.variable = _.cloneDeep(defaultVariable);
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/variable";
.credit-card-payment-clients-form {
  .btn-submit {
    text-align: center !important;
  }
  .border-bottom {
    border-bottom: 1.5px solid color(border-color);
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
